import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import SettingsIcon from 'shared/assets/32/SettingsIcon';
// import { Checkboxes, CheckboxesDropdownContainer, CheckboxesDropdownItem } from 'shared/components/projectsSearchBar/style';
// import { MagicBoxRow } from 'shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar';
// import { ClickOutsideComponent } from 'shared/components/CommentsController/components/ClickOutside';
import { useTranslation } from 'react-i18next';
import { FlexBox, Skeleton, useIsMobile } from '@brg/ui';
import { useDispatch, useSelector } from 'react-redux';
import { STATUSES, STATUSES_NEW } from '../../const';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import {
  CompetitionContainer,
  CompetitionDescriptionWrapper,
  CompetitionLogo, CompetitionDescriptionFull, CompetitionShowMoreContent,
  CompetitionSortOuter,
  // AwardsFiltersSortBar,
  CompetitionTabsSortRow,
  InterLogo,
  CompetitionActionLink,
  CompetitionActionsGroup,
} from './styled';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { getEnumOptions } from './helpers/competitionUtils';
import './styles.css';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { COMPETITION_ADMIN_TABS, COMPETITION_VIEW_TABS } from 'shared/pages/exploreHseContextsOldDeprecated/const/tabs';
import useQueryState from 'shared/hooks/useQueryState';
import { HseContextActions } from "../../../shared/reducers/hseCurrentContext";
import { BottomGroupWrapper } from 'shared/pages/explore/styles';
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "../../../shared/helpers/coloring";
import { CustomBgWrapper } from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import { AppTester } from "../../../supporting";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from './const/competitionContexts';
import ProjectsButchControllerUltimate from 'core/controllers/ProjectsButchControllerUltimate';
import { ProjectsGridActions } from 'shared/reducers/ProjectsGridSlice';
import useCompetitionTabs from './hooks/useCompetitionsTabs';
import { CompetitionTagsCloud } from "./competitionTagsCloud";
import { COMPETITIONS_ADD_TABS } from './const/competitionAddTabs';
import { getPathContext } from 'core/helpers/getPathContext';
import { useShowcaseTexts } from './hooks/useShowcaseTexts';
import { slashPathIndex } from 'shared/constants/enginePaths';
import { CoreContainer } from 'core';
import { useRouteMatch } from 'react-router-dom';

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

interface OptionProps {
  name: string
  identifier: number
}

export interface RefreshListProps {
  pageNumber: number
  i18n: any
  selectedStatus?: OptionProps
  dispatch: any;
  contexts: string[];
  isBriefCompetition?: boolean;
}

export const AllCompetitionsPage = () => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES_NEW, t), [t]);
  const [winnersSorting, setWinnersSorting] = useState(1);
  const dispatch = useDispatch();
  const { isLoading } = useSelector(CompetitionsSelector);
  const theme1 = useTheme();
  const { theme } = createThemeByColor(theme1.competition.bg, theme1);
  const isExamPage = useRouteMatch('/exams');
  const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
  const isAcademy = AppTester.isAcademy();
  const isCGRave = AppTester.isCGRAVE();
  const isExams = AppTester.isExamHSE();
  const isRusstart = AppTester.isStartHSE() && isExamPage;
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMediiia = AppTester.isMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isPortfolio365 = AppTester.isPortfolio365();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isCompetition = AppTester.isCompetition();
  const isUrbanAwards = AppTester.isMediiiaUrban()
  const isArtMediiia = AppTester.isArtMediiia()
  const isKiiidsMediiia = AppTester.isKiiidsMediiia()
  const isHseCreative = AppTester.isCreativeHSE()
  const isBrnd = AppTester.isBrnd()
  const isGame = AppTester.isGameDeziiign();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isHseSpace = AppTester.isHseSpace();
  const isHseSpaceMain = AppTester.isHseSpaceMain();
  const isHSESpaceSegmants = AppTester.isHSESpaceSegmants();
  const isGeoDafes = AppTester.isGeoDafes();
  const isNewDafesDesign = AppTester.isNewDafesDesign();
  const isNewDafesArt = AppTester.isNewDafesArt();
  const isNewDafesFashion = AppTester.isNewDafesFashion();
  const isNewDafesEducation = AppTester.isNewDafesEducation();
  const isNewDafesSegment = AppTester.isNewDafesSegment();
  const { tabsFormatted, commonFilter } = useCompetitionTabs();
  const isBooksMediiia = AppTester.isBooksMediiia()
  const isMediiiaCine = AppTester.isMediiiaCine()
  const isMediiiaAi = AppTester.isMediiiaAi()
  const isHistoryMediiia = AppTester.isHistoryMediiia()
  const isMediiiaStories = AppTester.isMediiiaStories()
  const isMusicMediiia = AppTester.isMusicMediiia()
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMediiiaFood = AppTester.isMediiiaFood()
  const isMediiiaProf = AppTester.isMediiiaProf()
  const isMediiiaNature = AppTester.isMediiiaNature()
  const isLectureMediiia = AppTester.isLectureMediiia()
  const hseAnimation = AppTester.isHseAnimation();
  const isMediiiaConcept = AppTester.isMediiiaConcept()
  const isMediiiaAuto = AppTester.isMediiiaAuto()
  const isEvent = AppTester.isContext('eventmediiia');
  const isStart = AppTester.isStartHSE();
  const isAKI = AppTester.isAKI()
  const isFairArtz = AppTester.isFairArtz() 
  const isPortfolioArtz = AppTester.isPortfolioArtz()
  const isArtzWork = isFairArtz || isPortfolioArtz
  const isMediiiaAd = AppTester.isMediiiaAd()
  const isStartTestsRoute = useRouteMatch('/exams');
  const isStarAwardsRoute = useRouteMatch('/awards');
  const isGaResults = useRouteMatch('/results');
  const isCreativeCity = AppTester.isAcademy()

  const isMediiiaContextWithTabs = isArtMediiia || isKiiidsMediiia || isBooksMediiia || isMediiiaCine || isMediiiaAi || isHistoryMediiia || isMediiiaStories || isMediiiaAuto ||
    isMusicMediiia || isMediiiaFood || isMediiiaProf || isMediiiaNature || isLectureMediiia || isMediiiaConcept || isMediiiaSport || isEvent || isMediiiaAd

  const { application, mode: env } = getPathContext();

  const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
    const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
    const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
    let name = ''
    if (!!splittedCtx) {
      name = removeMediiia(splittedCtx);
    }
    return { has, name }
  }, [application]);

  const isGreenAwardResult = useMemo(() => {
    return isGreenAward && isGaResults
  } , [isGreenAward, isGaResults])

  const navItems = useMemo(() => {
    if (isAKI || hseAnimation || isPortfolio365 || isKiiidsArt || isBrnd || (isMediaContext && !isUrbanAwards && !isMediiiaContextWithTabs) || (isLectureMediiia && !isMediiiaContextWithTabs)) return {};
    return {
      ...tabsFormatted?.map((i) => i?.name)
        ?.filter((i) => i !== COMPETITIONS_CONTEXTS.briefs)
        ?.reduce((a, v) => {
          const key = isLabDeziiign && v === COMPETITIONS_CONTEXTS.concept ? 'allDeziiignCompetitions' :
            (isFashionDeziiign || isUrbanAwards || isGame) && v === COMPETITIONS_CONTEXTS.concept ? 'fashion_concept' :
              isHSESpaceSegmants && v === COMPETITIONS_CONTEXTS.hsespace_awards ? 'space_concept' :
                v === COMPETITIONS_CONTEXTS.mediiiaad ? 'admediiiawards' :
                v
          return { ...a, [v]: t(`tab_names.competition_tabs.${key}`).toLowerCase() }
        }, {})
    }
  }, [isPortfolio365, isKiiidsArt, isUrbanAwards, tabsFormatted, isBrnd, isMediaContext, t])

  const getMediiiaContextFromAppTester = () => {
    if (isBooksMediiia) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isMediiiaCine) return COMPETITIONS_CONTEXTS.cinemediiiawards;
    if (isMediiiaAi) return COMPETITIONS_CONTEXTS.aimediiiawards;
    if (isHistoryMediiia) return COMPETITIONS_CONTEXTS.historymediiiawards;
    if (isMediiiaStories) return COMPETITIONS_CONTEXTS.storiesmediiiawards;
    if (isMediiiaAuto) return COMPETITIONS_CONTEXTS.automediiiawards;
    if (isMusicMediiia) return COMPETITIONS_CONTEXTS.musicmediiiawards;
    if (isMediiiaFood) return COMPETITIONS_CONTEXTS.foodmediiiawards;
    if (isMediiiaProf) return COMPETITIONS_CONTEXTS.profmediiiawards;
    if (isMediiiaNature) return COMPETITIONS_CONTEXTS.naturemediiiawards;
    if (isMediiiaConcept) return COMPETITIONS_CONTEXTS.conceptmediiiawards;
    if (isArtMediiia) return COMPETITIONS_CONTEXTS.artmediiiawards;
    if (isKiiidsMediiia) return COMPETITIONS_CONTEXTS.kiiidsmediiiawards;
    if (isEvent) return COMPETITIONS_CONTEXTS.eventmediiiawards;
    if (isMediiiaAd) return COMPETITIONS_CONTEXTS.mediiiaad;
    return null;
  };

  const initialTab = useMemo(() => {
    const getNewDafesCompetitionContext = () => {
      if (isNewDafesDesign) return COMPETITIONS_CONTEXTS.designawards;
      if (isNewDafesArt) return COMPETITIONS_CONTEXTS.artawards;
      if (isNewDafesFashion) return COMPETITIONS_CONTEXTS.fashionawards;
      if (isNewDafesEducation) return COMPETITIONS_CONTEXTS.educationawards;
      return null;
    };

    if (isFairArtz) return COMPETITIONS_CONTEXTS.fairartz;
    if (isPortfolioArtz) return COMPETITIONS_CONTEXTS.portfolioartz;

    const newDafesContext = getNewDafesCompetitionContext();
    if (newDafesContext) return newDafesContext;

    if (isMediaContext && mediaContextName && !isUrbanAwards) {
      return getMediiiaCompetitionContext(mediaContextName);
    }
    if (isLabDeziiign) return COMPETITIONS_CONTEXTS.ldAwards;
    if (isLectureMediiia) return COMPETITIONS_CONTEXTS.educationmediiiawards;
    if (isGame) return COMPETITIONS_CONTEXTS.gdawards;
    if (isFashionDeziiign) return COMPETITIONS_CONTEXTS.fdawards;
    if (isUrbanAwards) return COMPETITIONS_CONTEXTS.udawards;

    const mediiiaContext = getMediiiaContextFromAppTester();
    if (mediiiaContext) return mediiiaContext;

    if (isAKI) return COMPETITIONS_CONTEXTS.AKI_awards
    if (isHseCreative) return COMPETITIONS_CONTEXTS.hsecreativeawards;
    if (isMediiiaSport) return COMPETITIONS_CONTEXTS.sportmediiiawards;
    if (isGreenAward && !isGreenAwardResult) return COMPETITIONS_CONTEXTS.greenaward;
    if (isBooksGallllery) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isAdcrDafesNet) return COMPETITIONS_CONTEXTS.adcrawards;
    if (isBrnd) return COMPETITIONS_CONTEXTS.brndawards;
    if (isMediiia) return COMPETITIONS_CONTEXTS.mediiiaawards;
    if (isHSESpaceSegmants) return tabsFormatted[0]?.name;
    if (isHseSpace && !isHSESpaceSegmants) return COMPETITIONS_CONTEXTS.hsespace_awards;
    if (isStart) return isStartTestsRoute ? COMPETITIONS_CONTEXTS.russtart : COMPETITIONS_CONTEXTS.startawards;
    if (isHse) return COMPETITION_VIEW_TABS.competitions;
    if (isAcademy) return Object.keys(navItems)?.find((item) => item === 'citycompetitions');
    if (isCompetition) return Object.keys(navItems)?.find((item) => item === 'concept');
    if (isGreenAwardResult) return COMPETITIONS_CONTEXTS.greenaward2025

    return Object.keys(navItems)?.find((_, idx) => idx === 0);
  }, [isNewDafesDesign, isNewDafesArt, isNewDafesFashion, isNewDafesEducation, isGreenAwardResult, isHseCreative, isMediiiaSport, mediaContextName, isStartTestsRoute, isHSESpaceSegmants, isHseSpace, isGame, isFashionDeziiign, isUrbanAwards, isMediiia, isMediaContext, isHse, isAcademy, navItems, isCompetition, isGreenAward, isAdcrDafesNet, isBrnd, isArtMediiia, isKiiidsMediiia, isLabDeziiign, isLectureMediiia, isBooksGallllery, tabsFormatted])
  const [{ tab: currentTab = initialTab, sorting, tagId, ratingCompetitions }, setQueryParams] = useQueryState();
  // const [openCheckboxes, setOpenCheckboxes] = useState(false);
  const ratingCompetitionsOnly = !!ratingCompetitions;

  const { title, description } = useShowcaseTexts(currentTab);

  const currentSorting = useMemo(() =>
    ((isGreenAward && currentTab === COMPETITIONS_CONTEXTS.lastgreenaward))
      ? STATUSES_NEW.Completed
      : currentTab === 'winners'
        ? winnersSorting
        : currentTab === 'ratings'
          ? (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Completed)
          : (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Open)
    , [isGreenAward, currentTab, winnersSorting, isKiiidsArt, statusesOptions, sorting]);

  const sortingRef = useRef(sorting);
  const hasPerformedInitialCheckRef = useRef(false);

  useEffect(() => {
    sortingRef.current = currentSorting;
  }, [currentSorting])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier, tab: currentTab, tagId: null })
  }, [currentTab, setQueryParams])

  const handleProjectsLoaded = useCallback((projects: any[]) => {
    if (hasPerformedInitialCheckRef.current) return;

    hasPerformedInitialCheckRef.current = true;

    if (!isGreenAward && !isRusstart &&
      currentSorting === STATUSES_NEW.Open &&
      (!projects || projects.length === 0)) {
      setQueryParams({ sorting: STATUSES_NEW.Completed, tab: currentTab, tagId: null });
    }
  }, [currentSorting, currentTab, isGreenAward, setQueryParams])

  const onTabChange = (tab: string) => {
    const defaultSorting = tab === 'ratings' ? STATUSES_NEW.Completed : sortingRef.current;
    const isSameTab = tab === currentTab;
    setQueryParams({
      page: 1,
      tab,
      sorting: defaultSorting,
      ...(isSameTab ? {} : { tagId: undefined }),
    }, { replace: true });

    //setQueryParams({ page: 1, tab, tagId: undefined, sorting: defaultSorting }, { replace: true });
  }

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: COMPETITION_VIEW_TABS,
      initialTab: COMPETITION_VIEW_TABS.competitions,
      onSetTab: onTabChange
    }))
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, onTabChange])

  useEffect(() => {
    if (tabsFormatted?.length) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsFormatted,
        categories: [],
        mainFilter: commonFilter,
        context: `competition-list${isGreenAward ? `_${currentTab}` : ''}`,
      }))
    }
  }, [tabsFormatted, commonFilter, dispatch])

  useEffect(() => {
    if (!sorting && (currentTab === COMPETITION_ADMIN_TABS.ratings || isPortfolio365 || currentTab === 'ratings')) {
      setQueryParams({ sorting: STATUSES_NEW.Completed })
    }
  }, [isAcademy, currentTab, sorting])

  const isDarkTheme = useMemo(() => theme.competition.bg === '#343434', [theme])

  // const checkboxCircleColor = useMemo(() => {
  //   if (isHse) return '#146DEE';
  //   if (isGreenAward || isGeograffee) return '#89B644';
  //   return '#ff0000';
  // }, [isHse, isGreenAward, isGeograffee]);

  const activeTab = useMemo(
    () => {
      if (isHseCreative && currentTab === 'competitions') return 'hsecreativeawards'
      if (isHse && !isHseSpace && !isExams && !isStart && currentTab === 'competitions') return COMPETITIONS_CONTEXTS.main_hse
      if (isExams) return COMPETITIONS_CONTEXTS.exams
      if (isPortfolio365) return 'main_portfolio'
      if (isKiiidsArt) return COMPETITIONS_CONTEXTS.kiiids_awards
      if (hseAnimation) return COMPETITIONS_CONTEXTS.hseanimation
      return currentTab
    }, [isHse, currentTab, isHseCreative, isPortfolio365, isExams, isKiiidsArt, isStart]);

  useEffect(() => {
    if (activeTab === COMPETITIONS_CONTEXTS.main_hse) {
      onTabChange(COMPETITIONS_CONTEXTS.main_hse)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.citycompetitions) {
      onTabChange(COMPETITIONS_CONTEXTS.citycompetitions)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.concept) {
      onTabChange(COMPETITIONS_CONTEXTS.concept)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.mediiiaawards) {
      onTabChange(COMPETITIONS_CONTEXTS.mediiiaawards)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.startawards) {
      onTabChange(COMPETITIONS_CONTEXTS.startawards)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.russtart) {
      onTabChange(COMPETITIONS_CONTEXTS.russtart)
    }
  }, [])

  const competitionTabsCount = Object.keys(navItems).length;
  const competitionMaxVisibleTabs = Math.max(competitionTabsCount, 1);

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent
      {...props}
    >
      {props.children}
    </CompetitionShowMoreContent>
  )

  const sortFilter = useMemo(() => ({
    sort: Number(sorting) === 5 ? 2 : 1,
    limit: 20,
  }), [sorting]);

  const competitionStatus = useMemo(() => {
    if (isGreenAward) {
      return [
        STATUSES.Open,
        STATUSES.Summarizing,
        STATUSES.Voting,
        STATUSES.LonglistFormation,
        STATUSES.Completed,
        STATUSES.Announcement,
      ]
    }
    return (Number(sorting) === 1 || !sorting || activeTab === 'winners')
      ? [STATUSES.Open, STATUSES.Summarizing, STATUSES.Voting, STATUSES.LonglistFormation]
      : [STATUSES.Completed, STATUSES.Archived]
  }, [isGreenAward, sorting, activeTab])

  const tagFilter = useMemo(() => {
    if (tabsFormatted?.length) {
      const tab = tabsFormatted.find(({ name }) => name === activeTab)
      return {
        ...tab?.filter,
        competitionStatus,
        ...(ratingCompetitionsOnly ? { isRating: true } : {}),
      }
    }
  }, [activeTab, tabsFormatted, competitionStatus, ratingCompetitionsOnly])

  const shouldVisibleTagsCloud = useMemo(() => {
    return tagFilter && !isGreenAward && !hseAnimation
  }, [tagFilter, isGreenAward, hseAnimation])

  const shouldVisibleNavigation = useMemo(() => {
    if (isGreenAward && !isGreenAwardResult) return null;
    if (isExams) return null;
    if (hseAnimation) return null;
    if (isStart && isStarAwardsRoute) return null
    return true
  }, [isStart, isStarAwardsRoute, isGreenAwardResult, isGreenAward, hseAnimation, isExams])

  const content = useMemo(() => {
    if (![
      COMPETITION_VIEW_TABS.winners,
      COMPETITIONS_ADD_TABS.jury,
      COMPETITIONS_ADD_TABS.figurine,
      COMPETITIONS_ADD_TABS.rules
    ]?.includes(currentTab)) {
      return (
        <ProjectsButchControllerUltimate
          filter={{
            ...sortFilter,
            contexts: commonFilter.contexts,
            ...(tagId && { byTagIds: [tagId] }),
            competitionStatus,
            ...(ratingCompetitionsOnly ? { isRating: true } : {}),
          }}
          loading={false}
          currentCategory='main'
          currentTab={activeTab}
          contextName={`competition-list${isGreenAward ? `_${currentTab}` : ''}`}
          isMainPage
          scrollStyles={{ overflowX: 'hidden' }}
          isCompetitions
          onProjectsLoaded={handleProjectsLoaded}
        />
      )
    }
  }, [sortFilter, activeTab, currentTab, isCGRave, isGreenAward, commonFilter.contexts, tagId, competitionStatus, ratingCompetitionsOnly, handleProjectsLoaded])

  return (
    <ThemeProvider theme={theme as any}>
      <CustomBgWrapper backgroundColor={theme1.competition.bg}>
        <CoreContainer>
          <>
            <FlexBox justify={'flex-start'} justifyMobile='left' offsetTop={0} offsetTopMobile={"0px"}>
              {isAcademy ? (
                <InterLogo>
                  {title}
                </InterLogo>
              ) : (
                <CompetitionLogo smallOffset={isCGRave} isAlumni={!isHse} isHSEDesign={isHse}>
                  {title}
                </CompetitionLogo>
              )}
            </FlexBox>
            <BottomGroupWrapper disableOffset={isCGRave} isCGRave={isCGRave}>
              <FlexBox widthMobile={"100%"} style={{ whiteSpace: 'pre-wrap' }}>
                <CompetitionDescriptionWrapper>
                  {isNewDafesSegment ? (
                    <CompetitionDescriptionFull>
                      {isGreenAward ? (
                        <span dangerouslySetInnerHTML={{ __html: description }} />
                      ) : (
                        description
                      )}
                    </CompetitionDescriptionFull>
                  ) : (
                    <ShowMore
                      importantStyles
                      more={t('show_more_text')}
                      less={t('show_less_text')}
                      lines={4}
                    >
                      {isGreenAward ? (
                        <span dangerouslySetInnerHTML={{ __html: description }} />
                      ) : (
                        description
                      )}
                    </ShowMore>
                  )}
                </CompetitionDescriptionWrapper>
              </FlexBox>
            </BottomGroupWrapper>
          </>
          {!(isStart || isNewDafesDesign) && (
            <CompetitionActionsGroup>
               <FlexBox widthMobile="100%">
                <CompetitionActionLink
                  href="https://hsedesign.ru/partners"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BrgButton 
                      variant={ButtonVariant.Filled}
                      style={isAKI || isGame || isCreativeCity ? {} : {
                        background: '#FFFFFF',
                        color: '#151514'
                      }}
                  >
                    {t('for_organizers')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
              <FlexBox>
                <CompetitionActionLink
                  href="https://hsedesign.ru/teams/form/c085973ffadf4176a54edb667bf1f5cf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BrgButton
                    variant={ButtonVariant.Hollow}
                  >
                    {t('publish_competition')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
             
              <FlexBox widthMobile="100%">
                <CompetitionActionLink
                  href="mailto:creativeopen@hsedesign.ru"
                >
                  <BrgButton variant={ButtonVariant.Hollow}>
                    {t('technical_support')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
            </CompetitionActionsGroup>
          )}
          {<FlexBox offsetTop={24} direction='column' directionMobile='column' justify='space-between'>
            <CompetitionTabsSortRow
              justify={shouldVisibleNavigation ? 'space-between' : 'flex-end'}
              align="center"
            >
              {shouldVisibleNavigation ? (
                <FlexBox style={{ flex: 1, minWidth: 0 }}>
                  <SlideNavigation
                    activeIndexKey={activeTab}
                    onChange={onTabChange}
                    items={navItems}
                    maxVisibleItems={competitionMaxVisibleTabs}
                    autoFlex
                    autoWidth={false}
                    noLeftPadding
                    isLoading={isLoading}
                    whiteTheme={false}
                    isCompetition={true}
                    showActiveTabUnderline
                  />
                </FlexBox>
              ) : null}

              <CompetitionSortOuter
                direction="row"
                justify={'flex-end'}
                directionMobile="row"
                align='flex-end'
                alignMobile='center'
                themeType={isGeograffee ? 'grey' : isCGRave ? 'black' : 'white'}
                isGeograffee={isGeograffee}
              >
                {/* {isStarAwardsRoute ? (
                  <AwardsFiltersSortBar align="center">
                    <ThemeProvider theme={theme1 as any}>
                      <ClickOutsideComponent onClose={() => setOpenCheckboxes(false)}>
                        <Checkboxes circleColor={checkboxCircleColor} isAnyChecked={ratingCompetitionsOnly}>
                          <div onClick={() => setOpenCheckboxes(!openCheckboxes)}>
                            <div className="sortbar-checkbox-icon-wrapper">
                              <SettingsIcon />
                            </div>
                          </div>
                          {openCheckboxes && (
                            <CheckboxesDropdownContainer>
                              <CheckboxesDropdownItem style={{ placeItems: 'center' }}>
                                <MagicBoxRow
                                  label={t('filter.rating_competitions')}
                                  checked={ratingCompetitionsOnly}
                                  style={{ margin: isMobile ? '0' : '0 0 0 0', color: theme1.sortByColor }}
                                  onClick={() => {
                                    setQueryParams({
                                      ratingCompetitions: !ratingCompetitionsOnly,
                                      page: 1,
                                    });
                                  }}
                                />
                              </CheckboxesDropdownItem>
                            </CheckboxesDropdownContainer>
                          )}
                        </Checkboxes>
                      </ClickOutsideComponent>
                    </ThemeProvider>
                    {!isGreenAward && (
                      <CompetitionDropdown
                        bare
                        selectedSorting={currentSorting}
                        onSortingChange={onChangeStatus}
                        sortingMethods={statusesOptions}
                        isDarkTheme={isDarkTheme}
                      />
                    )}
                  </AwardsFiltersSortBar>
                ) : ( */}
                {!isGreenAward && (
                  <CompetitionDropdown
                    selectedSorting={currentSorting}
                    onSortingChange={onChangeStatus}
                    sortingMethods={statusesOptions}
                    isDarkTheme={isDarkTheme}
                  />
                )}
                {/* )} */}
              </CompetitionSortOuter>
            </CompetitionTabsSortRow>
          </FlexBox>}
          {shouldVisibleTagsCloud && (
            <CompetitionTagsCloud filter={tagFilter} />
          )}
          {isLoading && currentTab !== COMPETITION_VIEW_TABS.winners && (
            <CompetitionContainer>
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
            </CompetitionContainer>
          )}
          {content}
        </CoreContainer>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import SettingsIcon from 'shared/assets/32/SettingsIcon';
// import { Checkboxes, CheckboxesDropdownContainer, CheckboxesDropdownItem } from 'shared/components/projectsSearchBar/style';
// import { MagicBoxRow } from 'shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar';
// import { ClickOutsideComponent } from 'shared/components/CommentsController/components/ClickOutside';
import { useTranslation } from 'react-i18next';
import { FlexBox, Skeleton, useIsMobile } from '@brg/ui';
import { useDispatch, useSelector } from 'react-redux';
import { STATUSES, STATUSES_NEW } from '../../const';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import {
  CompetitionContainer,
  CompetitionDescriptionWrapper,
  CompetitionLogo, CompetitionDescriptionFull, CompetitionShowMoreContent,
  CompetitionSortOuter,
  // AwardsFiltersSortBar,
  CompetitionTabsSortRow,
  InterLogo,
  CompetitionActionLink,
  CompetitionActionsGroup,
} from './styled';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { getEnumOptions } from './helpers/competitionUtils';
import './styles.css';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { COMPETITION_ADMIN_TABS, COMPETITION_VIEW_TABS } from 'shared/pages/exploreHseContextsOldDeprecated/const/tabs';
import useQueryState from 'shared/hooks/useQueryState';
import { HseContextActions } from "../../../shared/reducers/hseCurrentContext";
import { BottomGroupWrapper } from 'shared/pages/explore/styles';
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "../../../shared/helpers/coloring";
import { CustomBgWrapper } from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import { AppTester } from "../../../supporting";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from './const/competitionContexts';
import ProjectsButchControllerUltimate from 'core/controllers/ProjectsButchControllerUltimate';
import { ProjectsGridActions } from 'shared/reducers/ProjectsGridSlice';
import useCompetitionTabs from './hooks/useCompetitionsTabs';
import { CompetitionTagsCloud } from "./competitionTagsCloud";
import { COMPETITIONS_ADD_TABS } from './const/competitionAddTabs';
import { getPathContext } from 'core/helpers/getPathContext';
import { useShowcaseTexts } from './hooks/useShowcaseTexts';
import { slashPathIndex } from 'shared/constants/enginePaths';
import { CoreContainer } from 'core';
import { useRouteMatch } from 'react-router-dom';

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

interface OptionProps {
  name: string
  identifier: number
}

export interface RefreshListProps {
  pageNumber: number
  i18n: any
  selectedStatus?: OptionProps
  dispatch: any;
  contexts: string[];
  isBriefCompetition?: boolean;
}

export const AllCompetitionsPage = () => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES_NEW, t), [t]);
  const [winnersSorting, setWinnersSorting] = useState(1);
  const dispatch = useDispatch();
  const { isLoading } = useSelector(CompetitionsSelector);
  const theme1 = useTheme();
  const { theme } = createThemeByColor(theme1.competition.bg, theme1);
  const isExamPage = useRouteMatch('/exams');
  const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
  const isAcademy = AppTester.isAcademy();
  const isCGRave = AppTester.isCGRAVE();
  const isExams = AppTester.isExamHSE();
  const isRusstart = AppTester.isStartHSE() && isExamPage;
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMediiia = AppTester.isMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isPortfolio365 = AppTester.isPortfolio365();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isCompetition = AppTester.isCompetition();
  const isUrbanAwards = AppTester.isMediiiaUrban()
  const isArtMediiia = AppTester.isArtMediiia()
  const isKiiidsMediiia = AppTester.isKiiidsMediiia()
  const isHseCreative = AppTester.isCreativeHSE()
  const isBrnd = AppTester.isBrnd()
  const isGame = AppTester.isGameDeziiign();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isHseSpace = AppTester.isHseSpace();
  const isHseSpaceMain = AppTester.isHseSpaceMain();
  const isHSESpaceSegmants = AppTester.isHSESpaceSegmants();
  const isGeoDafes = AppTester.isGeoDafes();
  const isNewDafesDesign = AppTester.isNewDafesDesign();
  const isNewDafesArt = AppTester.isNewDafesArt();
  const isNewDafesFashion = AppTester.isNewDafesFashion();
  const isNewDafesEducation = AppTester.isNewDafesEducation();
  const isNewDafesSegment = AppTester.isNewDafesSegment();
  const { tabsFormatted, commonFilter } = useCompetitionTabs();
  const isBooksMediiia = AppTester.isBooksMediiia()
  const isMediiiaCine = AppTester.isMediiiaCine()
  const isMediiiaAi = AppTester.isMediiiaAi()
  const isHistoryMediiia = AppTester.isHistoryMediiia()
  const isMediiiaStories = AppTester.isMediiiaStories()
  const isMusicMediiia = AppTester.isMusicMediiia()
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMediiiaFood = AppTester.isMediiiaFood()
  const isMediiiaProf = AppTester.isMediiiaProf()
  const isMediiiaNature = AppTester.isMediiiaNature()
  const isLectureMediiia = AppTester.isLectureMediiia()
  const hseAnimation = AppTester.isHseAnimation();
  const isMediiiaConcept = AppTester.isMediiiaConcept()
  const isMediiiaAuto = AppTester.isMediiiaAuto()
  const isEvent = AppTester.isContext('eventmediiia');
  const isStart = AppTester.isStartHSE();
  const isAKI = AppTester.isAKI()
  const isFairArtz = AppTester.isFairArtz() 
  const isPortfolioArtz = AppTester.isPortfolioArtz()
  const isArtzWork = isFairArtz || isPortfolioArtz
  const isMediiiaAd = AppTester.isMediiiaAd()
  const isStartTestsRoute = useRouteMatch('/exams');
  const isStarAwardsRoute = useRouteMatch('/awards');
  const isGaResults = useRouteMatch('/results');
  const isCreativeCity = AppTester.isAcademy()

  const isMediiiaContextWithTabs = isArtMediiia || isKiiidsMediiia || isBooksMediiia || isMediiiaCine || isMediiiaAi || isHistoryMediiia || isMediiiaStories || isMediiiaAuto ||
    isMusicMediiia || isMediiiaFood || isMediiiaProf || isMediiiaNature || isLectureMediiia || isMediiiaConcept || isMediiiaSport || isEvent || isMediiiaAd

  const { application, mode: env } = getPathContext();

  const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
    const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
    const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
    let name = ''
    if (!!splittedCtx) {
      name = removeMediiia(splittedCtx);
    }
    return { has, name }
  }, [application]);

  const isGreenAwardResult = useMemo(() => {
    return isGreenAward && isGaResults
  } , [isGreenAward, isGaResults])

  const navItems = useMemo(() => {
    if (isAKI || hseAnimation || isPortfolio365 || isKiiidsArt || isBrnd || (isMediaContext && !isUrbanAwards && !isMediiiaContextWithTabs) || (isLectureMediiia && !isMediiiaContextWithTabs)) return {};
    return {
      ...tabsFormatted?.map((i) => i?.name)
        ?.filter((i) => i !== COMPETITIONS_CONTEXTS.briefs)
        ?.reduce((a, v) => {
          const key = isLabDeziiign && v === COMPETITIONS_CONTEXTS.concept ? 'allDeziiignCompetitions' :
            (isFashionDeziiign || isUrbanAwards || isGame) && v === COMPETITIONS_CONTEXTS.concept ? 'fashion_concept' :
              isHSESpaceSegmants && v === COMPETITIONS_CONTEXTS.hsespace_awards ? 'space_concept' :
                v === COMPETITIONS_CONTEXTS.mediiiaad ? 'admediiiawards' :
                v
          return { ...a, [v]: t(`tab_names.competition_tabs.${key}`).toLowerCase() }
        }, {})
    }
  }, [isPortfolio365, isKiiidsArt, isUrbanAwards, tabsFormatted, isBrnd, isMediaContext, t])

  const getMediiiaContextFromAppTester = () => {
    if (isBooksMediiia) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isMediiiaCine) return COMPETITIONS_CONTEXTS.cinemediiiawards;
    if (isMediiiaAi) return COMPETITIONS_CONTEXTS.aimediiiawards;
    if (isHistoryMediiia) return COMPETITIONS_CONTEXTS.historymediiiawards;
    if (isMediiiaStories) return COMPETITIONS_CONTEXTS.storiesmediiiawards;
    if (isMediiiaAuto) return COMPETITIONS_CONTEXTS.automediiiawards;
    if (isMusicMediiia) return COMPETITIONS_CONTEXTS.musicmediiiawards;
    if (isMediiiaFood) return COMPETITIONS_CONTEXTS.foodmediiiawards;
    if (isMediiiaProf) return COMPETITIONS_CONTEXTS.profmediiiawards;
    if (isMediiiaNature) return COMPETITIONS_CONTEXTS.naturemediiiawards;
    if (isMediiiaConcept) return COMPETITIONS_CONTEXTS.conceptmediiiawards;
    if (isArtMediiia) return COMPETITIONS_CONTEXTS.artmediiiawards;
    if (isKiiidsMediiia) return COMPETITIONS_CONTEXTS.kiiidsmediiiawards;
    if (isEvent) return COMPETITIONS_CONTEXTS.eventmediiiawards;
    if (isMediiiaAd) return COMPETITIONS_CONTEXTS.mediiiaad;
    return null;
  };

  const initialTab = useMemo(() => {
    const getNewDafesCompetitionContext = () => {
      if (isNewDafesDesign) return COMPETITIONS_CONTEXTS.designawards;
      if (isNewDafesArt) return COMPETITIONS_CONTEXTS.artawards;
      if (isNewDafesFashion) return COMPETITIONS_CONTEXTS.fashionawards;
      if (isNewDafesEducation) return COMPETITIONS_CONTEXTS.educationawards;
      return null;
    };

    if (isFairArtz) return COMPETITIONS_CONTEXTS.fairartz;
    if (isPortfolioArtz) return COMPETITIONS_CONTEXTS.portfolioartz;

    const newDafesContext = getNewDafesCompetitionContext();
    if (newDafesContext) return newDafesContext;

    if (isMediaContext && mediaContextName && !isUrbanAwards) {
      return getMediiiaCompetitionContext(mediaContextName);
    }
    if (isLabDeziiign) return COMPETITIONS_CONTEXTS.ldAwards;
    if (isLectureMediiia) return COMPETITIONS_CONTEXTS.educationmediiiawards;
    if (isGame) return COMPETITIONS_CONTEXTS.gdawards;
    if (isFashionDeziiign) return COMPETITIONS_CONTEXTS.fdawards;
    if (isUrbanAwards) return COMPETITIONS_CONTEXTS.udawards;

    const mediiiaContext = getMediiiaContextFromAppTester();
    if (mediiiaContext) return mediiiaContext;

    if (isAKI) return COMPETITIONS_CONTEXTS.AKI_awards
    if (isHseCreative) return COMPETITIONS_CONTEXTS.hsecreativeawards;
    if (isMediiiaSport) return COMPETITIONS_CONTEXTS.sportmediiiawards;
    if (isGreenAward && !isGreenAwardResult) return COMPETITIONS_CONTEXTS.greenaward;
    if (isBooksGallllery) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isAdcrDafesNet) return COMPETITIONS_CONTEXTS.adcrawards;
    if (isBrnd) return COMPETITIONS_CONTEXTS.brndawards;
    if (isMediiia) return COMPETITIONS_CONTEXTS.mediiiaawards;
    if (isHSESpaceSegmants) return tabsFormatted[0]?.name;
    if (isHseSpace && !isHSESpaceSegmants) return COMPETITIONS_CONTEXTS.hsespace_awards;
    if (isStart) return isStartTestsRoute ? COMPETITIONS_CONTEXTS.russtart : COMPETITIONS_CONTEXTS.startawards;
    if (isHse) return COMPETITION_VIEW_TABS.competitions;
    if (isAcademy) return Object.keys(navItems)?.find((item) => item === 'citycompetitions');
    if (isCompetition) return Object.keys(navItems)?.find((item) => item === 'concept');
    if (isGreenAwardResult) return COMPETITIONS_CONTEXTS.greenaward2025

    return Object.keys(navItems)?.find((_, idx) => idx === 0);
  }, [isNewDafesDesign, isNewDafesArt, isNewDafesFashion, isNewDafesEducation, isGreenAwardResult, isHseCreative, isMediiiaSport, mediaContextName, isStartTestsRoute, isHSESpaceSegmants, isHseSpace, isGame, isFashionDeziiign, isUrbanAwards, isMediiia, isMediaContext, isHse, isAcademy, navItems, isCompetition, isGreenAward, isAdcrDafesNet, isBrnd, isArtMediiia, isKiiidsMediiia, isLabDeziiign, isLectureMediiia, isBooksGallllery, tabsFormatted])
  const [{ tab: currentTab = initialTab, sorting, tagId, ratingCompetitions }, setQueryParams] = useQueryState();
  // const [openCheckboxes, setOpenCheckboxes] = useState(false);
  const ratingCompetitionsOnly = !!ratingCompetitions;

  const { title, description } = useShowcaseTexts(currentTab);

  const currentSorting = useMemo(() =>
    ((isGreenAward && currentTab === COMPETITIONS_CONTEXTS.lastgreenaward))
      ? STATUSES_NEW.Completed
      : currentTab === 'winners'
        ? winnersSorting
        : currentTab === 'ratings'
          ? (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Completed)
          : (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Open)
    , [isGreenAward, currentTab, winnersSorting, isKiiidsArt, statusesOptions, sorting]);

  const sortingRef = useRef(sorting);
  const hasPerformedInitialCheckRef = useRef(false);

  useEffect(() => {
    sortingRef.current = currentSorting;
  }, [currentSorting])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier, tab: currentTab, tagId: null })
  }, [currentTab, setQueryParams])

  const handleProjectsLoaded = useCallback((projects: any[]) => {
    if (hasPerformedInitialCheckRef.current) return;

    hasPerformedInitialCheckRef.current = true;

    if (!isGreenAward && !isRusstart &&
      currentSorting === STATUSES_NEW.Open &&
      (!projects || projects.length === 0)) {
      setQueryParams({ sorting: STATUSES_NEW.Completed, tab: currentTab, tagId: null });
    }
  }, [currentSorting, currentTab, isGreenAward, setQueryParams])

  const onTabChange = (tab: string) => {
    const defaultSorting = tab === 'ratings' ? STATUSES_NEW.Completed : sortingRef.current;
    const isSameTab = tab === currentTab;
    setQueryParams({
      page: 1,
      tab,
      sorting: defaultSorting,
      ...(isSameTab ? {} : { tagId: undefined }),
    }, { replace: true });

    //setQueryParams({ page: 1, tab, tagId: undefined, sorting: defaultSorting }, { replace: true });
  }

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: COMPETITION_VIEW_TABS,
      initialTab: COMPETITION_VIEW_TABS.competitions,
      onSetTab: onTabChange
    }))
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, onTabChange])

  useEffect(() => {
    if (tabsFormatted?.length) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsFormatted,
        categories: [],
        mainFilter: commonFilter,
        context: `competition-list${isGreenAward ? `_${currentTab}` : ''}`,
      }))
    }
  }, [tabsFormatted, commonFilter, dispatch])

  useEffect(() => {
    if (!sorting && (currentTab === COMPETITION_ADMIN_TABS.ratings || isPortfolio365 || currentTab === 'ratings')) {
      setQueryParams({ sorting: STATUSES_NEW.Completed })
    }
  }, [isAcademy, currentTab, sorting])

  const isDarkTheme = useMemo(() => theme.competition.bg === '#343434', [theme])

  // const checkboxCircleColor = useMemo(() => {
  //   if (isHse) return '#146DEE';
  //   if (isGreenAward || isGeograffee) return '#89B644';
  //   return '#ff0000';
  // }, [isHse, isGreenAward, isGeograffee]);

  const activeTab = useMemo(
    () => {
      if (isHseCreative && currentTab === 'competitions') return 'hsecreativeawards'
      if (isHse && !isHseSpace && !isExams && !isStart && currentTab === 'competitions') return COMPETITIONS_CONTEXTS.main_hse
      if (isExams) return COMPETITIONS_CONTEXTS.exams
      if (isPortfolio365) return 'main_portfolio'
      if (isKiiidsArt) return COMPETITIONS_CONTEXTS.kiiids_awards
      if (hseAnimation) return COMPETITIONS_CONTEXTS.hseanimation
      return currentTab
    }, [isHse, currentTab, isHseCreative, isPortfolio365, isExams, isKiiidsArt, isStart]);

  useEffect(() => {
    if (activeTab === COMPETITIONS_CONTEXTS.main_hse) {
      onTabChange(COMPETITIONS_CONTEXTS.main_hse)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.citycompetitions) {
      onTabChange(COMPETITIONS_CONTEXTS.citycompetitions)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.concept) {
      onTabChange(COMPETITIONS_CONTEXTS.concept)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.mediiiaawards) {
      onTabChange(COMPETITIONS_CONTEXTS.mediiiaawards)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.startawards) {
      onTabChange(COMPETITIONS_CONTEXTS.startawards)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.russtart) {
      onTabChange(COMPETITIONS_CONTEXTS.russtart)
    }
  }, [])

  const competitionTabsCount = Object.keys(navItems).length;
  const competitionMaxVisibleTabs = Math.max(competitionTabsCount, 1);

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent
      {...props}
    >
      {props.children}
    </CompetitionShowMoreContent>
  )

  const sortFilter = useMemo(() => ({
    sort: Number(sorting) === 5 ? 2 : 1,
    limit: 20,
  }), [sorting]);

  const competitionStatus = useMemo(() => {
    if (isGreenAward) {
      return [
        STATUSES.Open,
        STATUSES.Summarizing,
        STATUSES.Voting,
        STATUSES.LonglistFormation,
        STATUSES.Completed,
        STATUSES.Announcement,
      ]
    }
    return (Number(sorting) === 1 || !sorting || activeTab === 'winners')
      ? [STATUSES.Open, STATUSES.Summarizing, STATUSES.Voting, STATUSES.LonglistFormation]
      : [STATUSES.Completed, STATUSES.Archived]
  }, [isGreenAward, sorting, activeTab])

  const tagFilter = useMemo(() => {
    if (tabsFormatted?.length) {
      const tab = tabsFormatted.find(({ name }) => name === activeTab)
      return {
        ...tab?.filter,
        competitionStatus,
        ...(ratingCompetitionsOnly ? { isRating: true } : {}),
      }
    }
  }, [activeTab, tabsFormatted, competitionStatus, ratingCompetitionsOnly])

  const shouldVisibleTagsCloud = useMemo(() => {
    return tagFilter && !isGreenAward && !hseAnimation
  }, [tagFilter, isGreenAward, hseAnimation])

  const shouldVisibleNavigation = useMemo(() => {
    if (isGreenAward && !isGreenAwardResult) return null;
    if (isExams) return null;
    if (hseAnimation) return null;
    if (isStart && isStarAwardsRoute) return null
    return true
  }, [isStart, isStarAwardsRoute, isGreenAwardResult, isGreenAward, hseAnimation, isExams])

  const content = useMemo(() => {
    if (![
      COMPETITION_VIEW_TABS.winners,
      COMPETITIONS_ADD_TABS.jury,
      COMPETITIONS_ADD_TABS.figurine,
      COMPETITIONS_ADD_TABS.rules
    ]?.includes(currentTab)) {
      return (
        <ProjectsButchControllerUltimate
          filter={{
            ...sortFilter,
            contexts: commonFilter.contexts,
            ...(tagId && { byTagIds: [tagId] }),
            competitionStatus,
            ...(ratingCompetitionsOnly ? { isRating: true } : {}),
          }}
          loading={false}
          currentCategory='main'
          currentTab={activeTab}
          contextName={`competition-list${isGreenAward ? `_${currentTab}` : ''}`}
          isMainPage
          scrollStyles={{ overflowX: 'hidden' }}
          isCompetitions
          onProjectsLoaded={handleProjectsLoaded}
        />
      )
    }
  }, [sortFilter, activeTab, currentTab, isCGRave, isGreenAward, commonFilter.contexts, tagId, competitionStatus, ratingCompetitionsOnly, handleProjectsLoaded])

  return (
    <ThemeProvider theme={theme as any}>
      <CustomBgWrapper backgroundColor={theme1.competition.bg}>
        <CoreContainer>
          <>
            <FlexBox justify={'flex-start'} justifyMobile='left' offsetTop={0} offsetTopMobile={"0px"}>
              {isAcademy ? (
                <InterLogo>
                  {title}
                </InterLogo>
              ) : (
                <CompetitionLogo smallOffset={isCGRave} isAlumni={!isHse} isHSEDesign={isHse}>
                  {title}
                </CompetitionLogo>
              )}
            </FlexBox>
            <BottomGroupWrapper disableOffset={isCGRave} isCGRave={isCGRave}>
              <FlexBox widthMobile={"100%"} style={{ whiteSpace: 'pre-wrap' }}>
                <CompetitionDescriptionWrapper>
                  {isNewDafesSegment ? (
                    <CompetitionDescriptionFull>
                      {isGreenAward ? (
                        <span dangerouslySetInnerHTML={{ __html: description }} />
                      ) : (
                        description
                      )}
                    </CompetitionDescriptionFull>
                  ) : (
                    <ShowMore
                      importantStyles
                      more={t('show_more_text')}
                      less={t('show_less_text')}
                      lines={4}
                    >
                      {isGreenAward ? (
                        <span dangerouslySetInnerHTML={{ __html: description }} />
                      ) : (
                        description
                      )}
                    </ShowMore>
                  )}
                </CompetitionDescriptionWrapper>
              </FlexBox>
            </BottomGroupWrapper>
          </>
          {!(isStart || isNewDafesDesign) && (
            <CompetitionActionsGroup>
               <FlexBox widthMobile="100%">
                <CompetitionActionLink
                  href="https://hsedesign.ru/partners"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BrgButton 
                      variant={ButtonVariant.Filled}
                      style={isAKI || isGame || isCreativeCity ? {} : {
                        background: '#FFFFFF',
                        color: '#151514'
                      }}
                  >
                    {t('for_organizers')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
              <FlexBox>
                <CompetitionActionLink
                  href="https://hsedesign.ru/teams/form/c085973ffadf4176a54edb667bf1f5cf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BrgButton
                    variant={ButtonVariant.Hollow}
                  >
                    {t('publish_competition')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
             
              <FlexBox widthMobile="100%">
                <CompetitionActionLink
                  href="mailto:creativeopen@hsedesign.ru"
                >
                  <BrgButton variant={ButtonVariant.Hollow}>
                    {t('technical_support')}
                  </BrgButton>
                </CompetitionActionLink>
              </FlexBox>
            </CompetitionActionsGroup>
          )}
          {<FlexBox offsetTop={24} direction='column' directionMobile='column' justify='space-between'>
            <CompetitionTabsSortRow
              justify={shouldVisibleNavigation ? 'space-between' : 'flex-end'}
              align="center"
            >
              {shouldVisibleNavigation ? (
                <FlexBox style={{ flex: 1, minWidth: 0 }}>
                  <SlideNavigation
                    activeIndexKey={activeTab}
                    onChange={onTabChange}
                    items={navItems}
                    maxVisibleItems={competitionMaxVisibleTabs}
                    autoFlex
                    autoWidth={false}
                    noLeftPadding
                    isLoading={isLoading}
                    whiteTheme={false}
                    isCompetition={true}
                    showActiveTabUnderline
                  />
                </FlexBox>
              ) : null}

              <CompetitionSortOuter
                direction="row"
                justify={'flex-end'}
                directionMobile="row"
                align='flex-end'
                alignMobile='center'
                themeType={isGeograffee ? 'grey' : isCGRave ? 'black' : 'white'}
                isGeograffee={isGeograffee}
              >
                {/* {isStarAwardsRoute ? (
                  <AwardsFiltersSortBar align="center">
                    <ThemeProvider theme={theme1 as any}>
                      <ClickOutsideComponent onClose={() => setOpenCheckboxes(false)}>
                        <Checkboxes circleColor={checkboxCircleColor} isAnyChecked={ratingCompetitionsOnly}>
                          <div onClick={() => setOpenCheckboxes(!openCheckboxes)}>
                            <div className="sortbar-checkbox-icon-wrapper">
                              <SettingsIcon />
                            </div>
                          </div>
                          {openCheckboxes && (
                            <CheckboxesDropdownContainer>
                              <CheckboxesDropdownItem style={{ placeItems: 'center' }}>
                                <MagicBoxRow
                                  label={t('filter.rating_competitions')}
                                  checked={ratingCompetitionsOnly}
                                  style={{ margin: isMobile ? '0' : '0 0 0 0', color: theme1.sortByColor }}
                                  onClick={() => {
                                    setQueryParams({
                                      ratingCompetitions: !ratingCompetitionsOnly,
                                      page: 1,
                                    });
                                  }}
                                />
                              </CheckboxesDropdownItem>
                            </CheckboxesDropdownContainer>
                          )}
                        </Checkboxes>
                      </ClickOutsideComponent>
                    </ThemeProvider>
                    {!isGreenAward && (
                      <CompetitionDropdown
                        bare
                        selectedSorting={currentSorting}
                        onSortingChange={onChangeStatus}
                        sortingMethods={statusesOptions}
                        isDarkTheme={isDarkTheme}
                      />
                    )}
                  </AwardsFiltersSortBar>
                ) : ( */}
                {!isGreenAward && (
                  <CompetitionDropdown
                    selectedSorting={currentSorting}
                    onSortingChange={onChangeStatus}
                    sortingMethods={statusesOptions}
                    isDarkTheme={isDarkTheme}
                  />
                )}
                {/* )} */}
              </CompetitionSortOuter>
            </CompetitionTabsSortRow>
          </FlexBox>}
          {shouldVisibleTagsCloud && (
            <CompetitionTagsCloud filter={tagFilter} />
          )}
          {isLoading && currentTab !== COMPETITION_VIEW_TABS.winners && (
            <CompetitionContainer>
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
            </CompetitionContainer>
          )}
          {content}
        </CoreContainer>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};
